<div class="col-12 header-questionario">
  <div class="header-questionario_container">
    <div>
      <div class="row">
        <div class="col d-flex justify-content-start pl-4">
          <img class="mt-3" src="src\assets\images\{{ logo }}" width="130" />
        </div>
        <div class="col d-flex justify-content-end pr-5">
          <div class="layout-breadcrumb">
            <div class="layout-breadcrumb_title">{{ title }}</div>
            <div class="layout-breadcrumb_subtitle">{{ subtitle }}</div>
            <div class="layout-breadcrumb_bottom"></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="progress-container">
            <div class="progress">
              <div
                class="progress-bar"
                role="progressbar"
                [style.width.%]="progressoPercentual"
                [attr.aria-valuenow]="progressoPercentual"
                [attr.aria-valuemin]="valueMin"
                [attr.aria-valuemax]="valueMax"
              >
                {{ progressoPercentual }}%
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
